export default __webpack_public_path__ + "static/media/four-bar.219c141e.png";